import styled from '@emotion/styled';

export const Wrapper = styled.div<{ size?: 'normal' | 'big'; color: 'light' | 'medium' }>`
  margin-bottom: 6px;
  text-align: left;
  font-weight: 600;
  color: ${(props) => props.theme.color[props.color].default};
  /* height: 18px;
  line-height: 18px; */
  font-size: 14px;
  font-weight: 700;

  ${(props) =>
    props.size === 'big' &&
    `
    margin-bottom: 15px;
    font-size: 16px;
  `}
`;

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  text-align: center;
  color: ${(props) => props.theme.color.blue.default};
  margin-right: 4px;
  display: inline-block;
`;

export const RequiredWrapper = styled.div<{ requiredColor?: 'red' | 'gray' }>`
  color: ${(props) => (props.requiredColor === 'red' ? props.theme.color.red.default : '#616b77')};
  margin-left: 6px;
  display: inline-block;
`;

export const OptionalWrapper = styled.div`
  color: ${(props) => props.theme.color.blue.default};
  margin-left: 6px;
  display: inline-block;
`;
